import { apiForPrivate } from '.';
import { SCRIPT_ENDPOINT } from '../../config/ap';

const apiScriptMaps = apiForPrivate.injectEndpoints({

  overrideExisting: true,
  
  endpoints: build => ({
    getScripts: build.query({
      query: () => SCRIPT_ENDPOINT.SCRIPTS,
    }),
    saveScript: build.mutation({
      query: (payload) => ({
        url: SCRIPT_ENDPOINT.SCRIPTS,
        method: 'POST',
        body: payload,
      }),
    }),
    updateScript: build.mutation({
      query: ({id, payload}) => ({
        url: `${SCRIPT_ENDPOINT.SCRIPTS}/${id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    deleteScript: build.mutation({
      query: (id) => ({
        url: `${SCRIPT_ENDPOINT.SCRIPTS}/${id}`,
        method: 'DELETE',
      }),
    })
  })
});

export const {
  useLazyGetScriptsQuery,
  useSaveScriptMutation,
  useUpdateScriptMutation,
  useDeleteScriptMutation,
} = apiScriptMaps;